import { trackWhatsAppLead } from '@/analytics';
import { clinicInfo } from '@/mockData';

function getUtmSuffix() {
  if (typeof window === 'undefined') return '';

  const params = new URLSearchParams(window.location.search);
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const parts = utmKeys
    .filter((key) => params.get(key))
    .map((key) => `${key}: ${params.get(key)}`);

  if (parts.length === 0) return '';
  return `\n\n(Origem site — ${parts.join(' | ')})`;
}

/**
 * Abre WhatsApp com mensagem contextualizada, UTM da URL e tracking de conversão.
 * @param {{ section: string, message: string }} options
 */
export function openWhatsApp({ section, message }) {
  const fullMessage = `${message}${getUtmSuffix()}`;
  trackWhatsAppLead(section);
  const encoded = encodeURIComponent(fullMessage);
  window.open(
    `https://wa.me/${clinicInfo.whatsapp}?text=${encoded}`,
    '_blank',
    'noopener,noreferrer',
  );
}
